import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../component/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import imageBaseUrl from '../../../../helpers/imageBaseUrl'
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../../store/actions"

import {
  Description_ar,
  Description_en,
  Description_fr,
  Is_vendor,
  // Position,
 Name_ar,Name_en,Name_fr
} from "./HowitworkListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../../components/Common/DeleteModal"
import Dropzone from "react-dropzone"
import { addNewHowitwork, deleteHowitwork, getHowitworks, updateHowitwork } from "../../../../store/how_it_works/actions"
import ReactSelect from "react-select"


function Howitworks() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [page,setPage]=useState(0)
  const [page_size, setPageSize] = useState(20)
  const [ceremony, setCeremony] = useState([])
  const [isVendor, setIsVendor] = useState({label:'Client',value:0})
const [selectedFiles, setselectedFiles] = useState([])

function handleAcceptedFiles(files) {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  )

  setselectedFiles(files)

}

/**
 * Formats the size
 */
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name_en: (ceremony && ceremony.name_en) || "",
      name_ar: (ceremony && ceremony.name_ar) || "",
      name_fr: (ceremony && ceremony.name_fr) || "",
      description_fr: (ceremony && ceremony.description_fr) || "",
      description_en: (ceremony && ceremony.description_en) || "",
      description_ar: (ceremony && ceremony.name_ar) || "",
      is_active: (ceremony && ceremony.is_active) || 0,
    },

    // validationSchema: Yup.object({
    //   name_ar: Yup.string().required("name ar is required"),
    //   name_fr: Yup.string().required("name fr is required"),
    //   name_en: Yup.string().required("name en is required"),
    // }),

    onSubmit: values => {

      if (isEdit) {
        const UpdateCeremony = {
          id: ceremony ? ceremony.id : 0,
          name_en: values["name_en"],
          name_fr: values["name_fr"],
          name_ar: values["name_ar"],
          description_en: values["description_en"],
          description_fr: values["description_fr"],
          description_ar: values["description_ar"],
          is_active: values["is_active"],
          for_vendor:isVendor.value,
          image: selectedFiles[0],
          removeImage: ceremony.removeImage ? 1 : 0,
        }

        // update ceremony
        dispatch(updateHowitwork(UpdateCeremony))
        validation.resetForm()
      } else {
        const newCeremony = {
          // id: Math.floor(Math.random() * (30 - 20)) + 20,
          name_en: values["name_en"],
          name_fr: values["name_fr"],
          name_ar: values["name_ar"],
          description_en: values["description_en"],
          description_fr: values["description_fr"],
          description_ar: values["description_ar"],
          is_active: values['is_active'],
          for_vendor:isVendor.value,
          image:selectedFiles[0]
        }
        // save new ceremony
        dispatch(addNewHowitwork(newCeremony))
        validation.resetForm()
        setselectedFiles([])
      }
      // toggle()
    },
  })

  const dispatch = useDispatch()
  const howitworks = useSelector(state => state.howitworks.howitworks)
  const total_pages = useSelector(state => state.howitworks.total_pages)
  const loading = useSelector(state => state.howitworks.loading)

  useEffect(() => {
    // if (howitworks && !howitworks.length) {
      dispatch(getHowitworks({is_active:0,offset:page,page_size}))
    // }
  }, [dispatch,page,page_size])

  // useEffect(() => {
  //   if (howitworks && !howitworks.length) {
  //     dispatch(onGetUsers())
  //   }
  // }, [dispatch, howitworks])

  // useEffect(() => {
  // }, [howitworks])

  useEffect(() => {
    if (!isEmpty(howitworks)) {
      setIsEdit(false)
    }
  }, [howitworks])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setCeremony(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const ceremony = arg
   ceremony?.image ? setselectedFiles([
      {
        preview:imageBaseUrl+ceremony.image
      }
    ]) : setselectedFiles([])
    setIsVendor(ceremony.for_vendor == 1 ? {label:'Vendor',value:1} : {label:'Client',value:0})
    setCeremony({
      id: ceremony.id,
      name_ar: ceremony.name_ar,
      name_fr: ceremony.name_fr,
      name_en: ceremony.name_en,
      description_en: ceremony.description_en,
          description_fr: ceremony.description_fr,
          description_ar: ceremony.description_ar,
      is_active:ceremony.is_active

    })
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete ceremony
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = ceremony => {
    setCeremony(ceremony)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (ceremony.id) {
      dispatch(deleteHowitwork(ceremony))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Image",

        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.image ? (
              <div className="avatar-xs d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : (
              <>
                <img
                  className="avatar-xs rounded-circle me-2"
                  src={imageBaseUrl + cellProps?.image}
                  alt=""
                />
              </>
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "Name en",
        accessor: "name_en",
        filterable: true,
        Cell: cellProps => {
          return <Name_en {...cellProps} />
        },
      },
      // {
      //   Header: "Position",
      //   accessor: "designation",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Position {...cellProps} />
      //   },
      // },
      {
        Header: "Name fr",
        accessor: "name_fr",
        filterable: true,
        Cell: cellProps => {
          return <Name_fr {...cellProps} />
        },
      },
      {
        Header: "Name ar",
        accessor: "name_ar",
        filterable: true,

        Cell: cellProps => {
          return <Name_ar {...cellProps} />
        },
        
      },
      {
        Header: "Description en",
        accessor: "description_en",
        filterable: true,

        Cell: cellProps => {
          return <Description_en {...cellProps} />
        },
        
      },
      {
        Header: "Description ar",
        accessor: "description_ar",
        filterable: true,

        Cell: cellProps => {
          return <Description_ar {...cellProps} />
        },
        
      },
      {
        Header: "Description fr",
        accessor: "description_fr",
        filterable: true,

        Cell: cellProps => {
          return <Description_fr {...cellProps} />
        },
      },
      {
        Header: "For",
        accessor: "for_vendor",
        filterable: false,
        disableFilters: true,

        Cell: cellProps => {
          // eslint-disable-next-line react/jsx-pascal-case
          return <Is_vendor {...cellProps} />
        },
        
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateHowitwork({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateHowitwork({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const howitworks = cellProps.row.original
                      handleUserClick(howitworks)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const howitworks = cellProps.row.original
                      onClickDelete(howitworks)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Ceremony type" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={howitworks}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setPage}
                    page_number={page}
                    total_pages={total_pages}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Dropzone
                  onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted uil uil-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedFiles.map((f, i) => {
                    return (
                      <Card
                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                        key={i + "-file"}
                      >
                        <div
                          className="p-2"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Row className="align-items-center">
                            <Col className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            </Col>
                            <Col>
                              <Link
                                to="#"
                                className="text-muted font-weight-bold"
                              >
                                {f.name}
                              </Link>
                              <p className="mb-0">
                                <strong>{f.formattedSize}</strong>
                              </p>
                            </Col>
                          </Row>
                          <div
                            className="align-self-center"
                            onClick={() => {
                              setselectedFiles([])
                              setCeremony(prev => ({ ...prev, removeImage: 1 }))
                            }}
                          >
                            <i
                              className="uil uil-trash-alt font-size-24 text-danger"
                              id="deletetooltip"
                            />
                            <UncontrolledTooltip
                              placement="top"
                              target="deletetooltip"
                            >
                              Delete
                            </UncontrolledTooltip>
                          </div>
                        </div>
                      </Card>
                    )
                  })}
                </div>
                <Row>
                  <Col className="col-12">
                    {/* <div className="mb-3">
                      <Label className="form-label">Position</Label> */}
                    {/* <Input
                        name="designation"
                        type="designation"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.designation || ""}
                        invalid={
                          validation.touched.designation &&
                          validation.errors.designation
                            ? true
                            : false
                        }
                      /> */}
                    {/* {validation.touched.designation &&
                      validation.errors.designation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.designation}
                        </FormFeedback>
                      ) : null} */}
                    {/* </div> */}
                    <div className="mb-3">
                      <Label className="form-label">Name en</Label>
                      <Input
                        name="name_en"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name_en || ""}
                        invalid={
                          validation.touched.name_en &&
                          validation.errors.name_en
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name_en &&
                      validation.errors.name_en ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name_en}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Name fr</Label>
                      <Input
                        name="name_fr"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name_fr || ""}
                        invalid={
                          validation.touched.name_fr &&
                          validation.errors.name_fr
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name_fr &&
                      validation.errors.name_fr ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name_fr}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Name ar</Label>
                      <Input
                        name="name_ar"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name_ar || ""}
                        invalid={
                          validation.touched.name_ar &&
                          validation.errors.name_ar
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name_ar &&
                      validation.errors.name_ar ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name_ar}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Description en</Label>
                      <Input
                        name="description_en"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description_en || ""}
                        invalid={
                          validation.touched.description_en &&
                          validation.errors.description_en
                            ? true
                            : false
                        }
                      />
                      {validation.touched.description_en &&
                      validation.errors.description_en ? (
                        <FormFeedback type="invalid">
                          {validation.errors.description_en}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">Description fr</Label>
                      <Input
                        name="description_fr"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description_fr || ""}
                        invalid={
                          validation.touched.description_fr &&
                          validation.errors.description_fr
                            ? true
                            : false
                        }
                      />
                      {validation.touched.description_fr &&
                      validation.errors.description_fr ? (
                        <FormFeedback type="invalid">
                          {validation.errors.description_fr}
                        </FormFeedback>
                      ) : null}
                    </div>

                       <div className="mb-3">
                      <Label className="form-label">Description ar</Label>
                      <Input
                        name="description_ar"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description_ar || ""}
                        invalid={
                          validation.touched.description_ar &&
                          validation.errors.description_ar
                            ? true
                            : false
                        }
                      />
                      {validation.touched.description_ar &&
                      validation.errors.description_ar ? (
                        <FormFeedback type="invalid">
                          {validation.errors.description_ar}
                        </FormFeedback>
                      ) : null}
                    </div>
                    
                    <div className="mb-3">
                      <Label className="form-label">For ?</Label>
                      <ReactSelect
                        value={isVendor}
                        onChange={(option, event) => {
                       
                          setIsVendor(option)
                        }}
                        options={[{label:"Vendor",value:1},{label:'Client',value:0}]}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active === 1 ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      {/* <input
                        type="checkbox"
                        className="selection-input-4 m-1"
                        defaultChecked={
                          validation.values.is_active === 1 ? true : false
                        }
                      /> */}
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Howitworks.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Howitworks
